// src/components/ForgivenessInfoSection.tsx
import React from 'react';

export const ForgivenessInfoSection: React.FC = () => {
  return (
    <section id="forgiveness-info" className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
      <div className="flex">
        <div className="ml-3">
          <h3 className="text-base font-semibold text-yellow-800">
            Perdão de Dívida - Rescisão e Recolhimento
          </h3>
          <div className="mt-2 text-base text-yellow-700">
            <p className="mb-2">
              <strong>Importante:</strong> Quando o cliente retorna o veículo, pode haver diferença entre o valor total em aberto e o valor cobrado.
            </p>
            <p className="mb-2 font-semibold">
              <strong>Cobramos apenas:</strong> Manutenção, excesso de quilometragem, avarias e multas de trânsito.
            </p>
            <p className="font-semibold">
              <strong>Perdoamos:</strong> Dívidas relacionadas à quebra de contrato e taxas de recolhimento, como gesto de boa vontade para facilitar a devolução do veículo.
            </p>
            <div className="mt-4 p-3 bg-orange-50 border border-orange-200 rounded-md">
              <h4 className="text-sm font-medium text-orange-800 mb-2">
                Como editar o valor total:
              </h4>
              <ul className="text-sm text-orange-700 space-y-1">
                <li>• <strong>Revise os itens marcados:</strong> Verifique quais débitos estão selecionados na tabela acima</li>
                <li>• <strong>Calcule apenas o cobrável:</strong> Some apenas manutenção, quilometragem, avarias e multas</li>
                <li>• <strong>Ajuste o valor final:</strong> Edite o campo "Valor Total" abaixo com o valor correto a ser cobrado</li>
                <li>• <strong>Desconsidere:</strong> Não inclua taxas de rescisão ou recolhimento (são perdoadas)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};